export enum WallColorKey {
    Anthracite = 'anthracite',
    Black = 'black',
    JuniperGreen = 'juniperGreen'
}

export interface WallColor {
    key: string
    name: string
    exampleHexColor: `#${string}`,
    sceneHexColor: `#${string}`
}

export const wallColors: WallColor[] = [{
    key: WallColorKey.Anthracite,
    name: 'Antraciet',
    exampleHexColor: '#404244',
    sceneHexColor: '#555555'
}, {
    key: WallColorKey.Black,
    name: 'Zwart',
    exampleHexColor: '#0e0e10',
    sceneHexColor: '#444444'
}, {
    key: WallColorKey.JuniperGreen,
    name: 'Juniper Green',
    exampleHexColor: '#425330',
    sceneHexColor: '#425330'
}]
